import { Component, OnInit } from '@angular/core';
import { MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-package-refresh-dialog',
    templateUrl: './package-refresh-dialog.component.html',
    styleUrls: ['./package-refresh-dialog.component.scss'],
    standalone: false
})
export class PackageRefreshDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PackageRefreshDialogComponent>) {
  }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  
  refreshPackage() {
    this.dialogRef.close();
  }

}
